import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
} from "../services/types/ComponentTypes";

export const screen_2217_emp_profile: any[] = [
    {
        "componentType": "screenGroup",
        "title": "Employee Profile",
        "style": {
            "backgroundColor": "hsl(var(--bg-background))",
            "padding": 0
        },
        "childComponents": [
            {
                "componentType": "profileHeaderCard",
                "style": {
                    "backgroundColor": "hsl(var(--color-primary))",
                    "padding": 32,
                    "borderRadius": 0,
                    "margin": 0,
                    "direction": "row",
                    "gap": 20
                },
                "fields": [
                    {
                        "componentType": "textField",
                        "name": "profile_name",
                        "label": "Employee Name",
                        "Json_Attribute": "name",
                        "BindValue": "primary_name",
                        "isReadOnly": true,
                        "disabled": true
                    },
                    {
                        "componentType": "textField",
                        "name": "profile_emp_code",
                        "label": "Employee Code",
                        "Json_Attribute": "employee_number",
                        "BindValue": "emp_code",
                        "isReadOnly": true,
                        "disabled": true
                    },
                    {
                        "componentType": "textField",
                        "name": "profile_designation",
                        "label": "Designation",
                        "Json_Attribute": "job_title_primary",
                        "BindValue": "job_job_title_primary",
                        "isReadOnly": true,
                        "disabled": true
                    },
                    {
                        "componentType": "textField",
                        "name": "profile_employee_id",
                        "label": "Employee ID",
                        "Json_Attribute": "employee_id",
                        "BindValue": "employee_id",
                        "isReadOnly": true,
                        "disabled": true
                    },
                    {
                        "componentType": "textField",
                        "name": "profile_avatar",
                        "label": "Profile Image",
                        "Json_Attribute": "profile_image",
                        "BindValue": "avatar",
                        "isReadOnly": true,
                        "disabled": true
                    }
                ]
            },
            {
                "componentType": "group",
                "style": {
                    "backgroundColor": "hsl(var(--bg-white))",
                    "padding": 24,
                    "margin": 0,
                    "borderRadius": 0
                },
                "childComponents": [
                    {
                        "componentType": "profileContactInfo",
                        "style": {
                            "backgroundColor": "transparent",
                            "padding": 0,
                            "borderRadius": 0,
                            "margin": 0
                        },
                        "fields": [
                            {
                                "componentType": "textField",
                                "name": "contact_email",
                                "label": "Email",
                                "Json_Attribute": "email",
                                "BindValue": "contact_email",
                                "isReadOnly": true,
                                "disabled": true
                            },
                            {
                                "componentType": "textField",
                                "name": "contact_phone",
                                "label": "Phone",
                                "Json_Attribute": "mobile",
                                "BindValue": "contact_phone",
                                "isReadOnly": true,
                                "disabled": true
                            },
                            {
                                "componentType": "textField",
                                "name": "contact_location",
                                "label": "Location",
                                "Json_Attribute": "location",
                                "BindValue": "contact_location",
                                "isReadOnly": true,
                                "disabled": true
                            },
                            {
                                "componentType": "textField",
                                "name": "contact_emp_code",
                                "label": "Employee Code",
                                "Json_Attribute": "employee_number",
                                "BindValue": "emp_code",
                                "isReadOnly": true,
                                "disabled": true
                            }
                        ]
                    },
                    {
                        "componentType": "profileDepartmentInfo",
                        "style": {
                            "backgroundColor": "transparent",
                            "padding": 0,
                            "borderRadius": 0,
                            "marginTop": 24
                        },
                        "fields": [
                            {
                                "componentType": "textField",
                                "name": "department_name",
                                "label": "DEPARTMENT",
                                "Json_Attribute": "department",
                                "BindValue": "organization_department",
                                "isReadOnly": true,
                                "disabled": true
                            },
                            {
                                "componentType": "textField",
                                "name": "sub_department_name",
                                "label": "SUB-DEPARTMENT",
                                "Json_Attribute": "sub_department",
                                "BindValue": "organization_sub_department",
                                "isReadOnly": true,
                                "disabled": true
                            },
                            {
                                "componentType": "textField",
                                "name": "reporting_manager",
                                "label": "REPORTING MANAGER",
                                "Json_Attribute": "reporting_manager",
                                "BindValue": "job_reporting_manager",
                                "lookupName": "admin_employees",
                                "isReadOnly": true,
                                "disabled": true
                            }
                        ]
                    }
                ]
            },
            {
                "componentType": "profileTabs",
                "style": {
                    "backgroundColor": "hsl(var(--bg-white))",
                    "padding": 24,
                    "borderRadius": 0,
                    "margin": 0
                },
                "config": {
                    "tabs": [
                        "about",
                        "profile",
                        "job",
                        "documents",
                        "assets"
                    ],
                    "tabConfigs": {
                        "about": {
                            "visibility": [
                                1,
                                2
                            ],
                            "sections": [
                                {
                                    "sectionId": "primary_details",
                                    "title": "Primary Details",
                                    "editDrawerId": "profile-primary-details-edit",
                                    "editTitle": "Edit Primary Details",
                                    "editConfigId": "primaryDetailsEditConfig",
                                    "saveActionId": "save_profile_primary_details",
                                    "fields": [
                                        {
                                            "componentType": "textField",
                                            "name": "primary_first_name",
                                            "label": "First Name",
                                            "Json_Attribute": "first_name",
                                            "BindValue": "primary_first_name",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "primary_middle_name",
                                            "label": "Middle Name",
                                            "Json_Attribute": "middle_name",
                                            "BindValue": "primary_middle_name",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "primary_last_name",
                                            "label": "Last Name",
                                            "Json_Attribute": "last_name",
                                            "BindValue": "primary_last_name",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "primary_name",
                                            "label": "Name",
                                            "Json_Attribute": "name",
                                            "BindValue": "primary_name",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "selectDropdown",
                                            "name": "primary_gender",
                                            "label": "Gender",
                                            "Json_Attribute": "gender",
                                            "BindValue": "primary_gender",
                                            "lookupName": "gender",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "primary_date_of_birth",
                                            "label": "Date of Birth",
                                            "Json_Attribute": "date_of_birth",
                                            "BindValue": "primary_date_of_birth",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "selectDropdown",
                                            "name": "primary_marital_status",
                                            "label": "Marital Status",
                                            "Json_Attribute": "marital_status",
                                            "BindValue": "primary_marital_status",
                                            "lookupName": "marital_status",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "primary_marriage_date",
                                            "label": "Marriage Date",
                                            "Json_Attribute": "marriage_date",
                                            "BindValue": "primary_marriage_date",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "searchableDropdown",
                                            "name": "primary_nationality",
                                            "label": "Nationality",
                                            "Json_Attribute": "nationality",
                                            "BindValue": "primary_nationality",
                                            "lookupName": "country",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "primary_languages_read",
                                            "label": "Languages Read",
                                            "Json_Attribute": "languages_read",
                                            "BindValue": "primary_languages_read",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "primary_languages_write",
                                            "label": "Languages Write",
                                            "Json_Attribute": "languages_write",
                                            "BindValue": "primary_languages_write",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "primary_languages_speak",
                                            "label": "Languages Speak",
                                            "Json_Attribute": "languages_speak",
                                            "BindValue": "primary_languages_speak",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "selectDropdown",
                                            "name": "primary_physically_handicapped",
                                            "label": "Physically Handicapped",
                                            "Json_Attribute": "physically_handicapped",
                                            "BindValue": "primary_physically_handicapped",
                                            "lookupName": "physically_handicapped",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "selectDropdown",
                                            "name": "primary_blood_group",
                                            "label": "Blood Group",
                                            "Json_Attribute": "blood_group_desc",
                                            "BindValue": "blood_group_desc",
                                            "lookupName": "blood_group",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "contact_details",
                                    "title": "Contact Details",
                                    "editDrawerId": "profile-contact-details-edit",
                                    "editTitle": "Edit Contact Details",
                                    "editConfigId": "contactDetailsEditConfig",
                                    "saveActionId": "save_profile_contact_details",
                                    "fields": [
                                        {
                                            "componentType": "textField",
                                            "name": "contact_email",
                                            "label": "Email",
                                            "Json_Attribute": "email",
                                            "BindValue": "contact_email",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "contact_phone",
                                            "label": "Mobile",
                                            "Json_Attribute": "mobile",
                                            "BindValue": "contact_phone",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "contact_personal_email",
                                            "label": "Personal Email",
                                            "Json_Attribute": "personal_email",
                                            "BindValue": "contact_personal_email",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "contact_residence_number",
                                            "label": "Residence Number",
                                            "Json_Attribute": "residence_number",
                                            "BindValue": "contact_residence_number",
                                            "columnNumber": "m1 t2 w3"
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "emergency_contact_1",
                                    "title": "Emergency Contact 1",
                                    "editDrawerId": "profile-emergency-contact-1-edit",
                                    "editTitle": "Edit Emergency Contact 1",
                                    "editConfigId": "emergencyContact1EditConfig",
                                    "saveActionId": "save_profile_emergency_contact_1",
                                    "fields": [
                                        {
                                            "componentType": "textField",
                                            "name": "emergency_contact_1_name",
                                            "label": "Name",
                                            "Json_Attribute": "emergency_contact_1_name",
                                            "BindValue": "emergency_contact_1_name",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "emergency_contact_1_phone",
                                            "label": "Mobile Phone",
                                            "Json_Attribute": "emergency_contact_1_phone",
                                            "BindValue": "emergency_contact_1_phone",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textArea",
                                            "name": "emergency_contact_1_address",
                                            "label": "Address",
                                            "Json_Attribute": "emergency_contact_1_address",
                                            "BindValue": "emergency_contact_1_address",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "emergency_contact_1_relationship",
                                            "label": "Relationship",
                                            "Json_Attribute": "emergency_contact_1_relationship",
                                            "BindValue": "emergency_contact_1_relationship",
                                            "lookupName": "emergency_contact_relationship",
                                            "columnNumber": "m1 t2 w3"
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "emergency_contact_2",
                                    "title": "Emergency Contact 2",
                                    "editDrawerId": "profile-emergency-contact-2-edit",
                                    "editTitle": "Edit Emergency Contact 2",
                                    "editConfigId": "emergencyContact2EditConfig",
                                    "saveActionId": "save_profile_emergency_contact_2",
                                    "fields": [
                                        {
                                            "componentType": "textField",
                                            "name": "emergency_contact_2_name",
                                            "label": "Name",
                                            "Json_Attribute": "emergency_contact_2_name",
                                            "BindValue": "emergency_contact_2_name",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "emergency_contact_2_phone",
                                            "label": "Mobile Phone",
                                            "Json_Attribute": "emergency_contact_2_phone",
                                            "BindValue": "emergency_contact_2_phone",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textArea",
                                            "name": "emergency_contact_2_address",
                                            "label": "Address",
                                            "Json_Attribute": "emergency_contact_2_address",
                                            "BindValue": "emergency_contact_2_address",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "emergency_contact_2_relationship",
                                            "label": "Relationship",
                                            "Json_Attribute": "emergency_contact_2_relationship",
                                            "BindValue": "emergency_contact_2_relationship",
                                            "lookupName": "emergency_contact_relationship",
                                            "columnNumber": "m1 t2 w3"
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "addresses",
                                    "title": "Addresses",
                                    "editDrawerId": "profile-addresses-edit",
                                    "editTitle": "Edit Addresses",
                                    "editConfigId": "addressesEditConfig",
                                    "saveActionId": "save_profile_addresses",
                                    "fields": [
                                        {
                                            "componentType": "textArea",
                                            "name": "address_current_address",
                                            "label": "Current Address",
                                            "Json_Attribute": "current_address",
                                            "BindValue": "address_current_address",
                                            "columnNumber": "m1 t1 w2"
                                        },
                                        {
                                            "componentType": "textArea",
                                            "name": "address_permanent_address",
                                            "label": "Permanent Address",
                                            "Json_Attribute": "permanent_address",
                                            "BindValue": "address_permanent_address",
                                            "columnNumber": "m1 t1 w2"
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "pan_card",
                                    "title": "Identity Information - PAN Card",
                                    "enabledForCountries": [
                                        "IN"
                                    ],
                                    "editDrawerId": "profile-pan-card-edit",
                                    "editTitle": "Edit PAN Card Details",
                                    "editConfigId": "panCardEditConfig",
                                    "saveActionId": "save_profile_pan_card",
                                    "fields": [
                                        {
                                            "componentType": "textField",
                                            "name": "pan_number",
                                            "label": "PAN Number",
                                            "Json_Attribute": "pan_number",
                                            "BindValue": "pan_number",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "pan_name",
                                            "label": "PAN Name",
                                            "Json_Attribute": "pan_name",
                                            "BindValue": "pan_name",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "pan_dob",
                                            "label": "PAN DOB",
                                            "Json_Attribute": "pan_dob",
                                            "BindValue": "pan_dob",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "pan_parent_name",
                                            "label": "PAN Parent Name",
                                            "Json_Attribute": "pan_parent_name",
                                            "BindValue": "pan_parent_name",
                                            "columnNumber": "m1 t2 w3"
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "aadhaar",
                                    "title": "Identity Information - Photo ID (Aadhaar)",
                                    "enabledForCountries": [
                                        "IN"
                                    ],
                                    "editDrawerId": "profile-aadhaar-edit",
                                    "editTitle": "Edit Aadhaar Details",
                                    "editConfigId": "aadhaarEditConfig",
                                    "saveActionId": "save_profile_aadhaar",
                                    "fields": [
                                        {
                                            "componentType": "selectDropdown",
                                            "name": "aadhaar_type",
                                            "label": "Photo ID Type",
                                            "Json_Attribute": "aadhaar_type",
                                            "BindValue": "aadhaar_type",
                                            "lookupName": "aadhaar_type",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "aadhaar_name",
                                            "label": "Name on Photo ID",
                                            "Json_Attribute": "aadhaar_name",
                                            "BindValue": "aadhaar_name",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "aadhaar_number",
                                            "label": "Photo ID Number",
                                            "Json_Attribute": "aadhaar_number",
                                            "BindValue": "aadhaar_number",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "aadhaar_dob",
                                            "label": "Date of Birth (as on ID)",
                                            "Json_Attribute": "aadhaar_dob",
                                            "BindValue": "aadhaar_dob",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "aadhaar_parent_name",
                                            "label": "Parent's Name (as on ID)",
                                            "Json_Attribute": "aadhaar_parent_name",
                                            "BindValue": "aadhaar_parent_name",
                                            "columnNumber": "m1 t2 w3"
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "identity_documents",
                                    "title": "Identity Documents (Emirates ID, Passport, Visa)",
                                    "enabledForCountries": [
                                        "UAE",
                                        "AE"
                                    ],
                                    "editDrawerId": "profile-identity-documents-edit",
                                    "editTitle": "Edit Identity Documents",
                                    "editConfigId": "identityDocumentsEditConfig",
                                    "saveActionId": "save_profile_identity_documents",
                                    "fields": [
                                        {
                                            "componentType": "textField",
                                            "name": "identity_emirates_id",
                                            "label": "Emirates ID",
                                            "Json_Attribute": "emirates_id",
                                            "BindValue": "identity_emirates_id",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "identity_emirates_issue_date",
                                            "label": "Emirates ID Issue Date",
                                            "Json_Attribute": "emirates_id_issue_date",
                                            "BindValue": "identity_emirates_issue_date",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "identity_emirates_expiry_date",
                                            "label": "Emirates ID Expiry Date",
                                            "Json_Attribute": "emirates_id_expiry_date",
                                            "BindValue": "identity_emirates_expiry_date",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "identity_passport_no",
                                            "label": "Passport No.",
                                            "Json_Attribute": "passport_no",
                                            "BindValue": "identity_passport_no",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "identity_passport_issue_date",
                                            "label": "Passport Issue Date",
                                            "Json_Attribute": "passport_issue_date",
                                            "BindValue": "identity_passport_issue_date",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "identity_passport_expiry_date",
                                            "label": "Passport Expiry Date",
                                            "Json_Attribute": "passport_expiry_date",
                                            "BindValue": "identity_passport_expiry_date",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "identity_visa_no",
                                            "label": "Visa No",
                                            "Json_Attribute": "visa_no",
                                            "BindValue": "identity_visa_no",
                                            "columnNumber": "m1 t2 w3"
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "employment_history",
                                    "title": "History of Employment",
                                    "editDrawerId": "profile-employment-history-edit",
                                    "editTitle": "Edit Employment History",
                                    "editConfigId": "employmentHistoryEditConfig",
                                    "saveActionId": "save_profile_employment_history",
                                    "fields": [
                                        {
                                            "componentType": "textField",
                                            "name": "employment_history_previous_company_name",
                                            "label": "Name of the Company",
                                            "Json_Attribute": "employment_history_previous_company_name",
                                            "BindValue": "employment_history_previous_company_name",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "employment_history_previous_employer_id",
                                            "label": "Previous Employer ID",
                                            "Json_Attribute": "employment_history_previous_employer_id",
                                            "BindValue": "employment_history_previous_employer_id",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "employment_history_previous_joining_date",
                                            "label": "Joining Date",
                                            "Json_Attribute": "employment_history_previous_joining_date",
                                            "BindValue": "employment_history_previous_joining_date",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "employment_history_previous_ending_date",
                                            "label": "Ending Date",
                                            "Json_Attribute": "employment_history_previous_ending_date",
                                            "BindValue": "employment_history_previous_ending_date",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "employment_history_total_employment",
                                            "label": "Total Duration of Employment",
                                            "Json_Attribute": "employment_history_total_employment",
                                            "BindValue": "employment_history_total_employment",
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "textArea",
                                            "name": "employment_history_reason_for_leaving",
                                            "label": "Reason for Leaving",
                                            "Json_Attribute": "employment_history_reason_for_leaving",
                                            "BindValue": "employment_history_reason_for_leaving",
                                            "columnNumber": "m1 t2 w3"
                                        }
                                    ]
                                }
                            ]
                        },
                        "profile": {
                            "visibility": [
                                2
                            ],
                            "sections": [
                                {
                                    "sectionId": "about",
                                    "title": "About",
                                    "editDrawerId": "profile-about-edit",
                                    "editTitle": "Edit About",
                                    "editConfigId": "aboutEditConfig",
                                    "saveActionId": "save_profile_about",
                                    "fields": [
                                        {
                                            "componentType": "textArea",
                                            "name": "about",
                                            "label": "About",
                                            "Json_Attribute": "about",
                                            "BindValue": "about",
                                            "columnNumber": "m1 t1 w1"
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "what_i_love",
                                    "title": "What I love about my job?",
                                    "editDrawerId": "profile-what-i-love-edit",
                                    "editTitle": "Edit What I Love",
                                    "editConfigId": "whatILoveEditConfig",
                                    "saveActionId": "save_profile_what_i_love",
                                    "fields": [
                                        {
                                            "componentType": "textArea",
                                            "name": "what_i_love",
                                            "label": "What I love about my job?",
                                            "Json_Attribute": "what_i_love",
                                            "BindValue": "what_i_love",
                                            "columnNumber": "m1 t1 w1"
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "interests",
                                    "title": "My interests and hobbies",
                                    "editDrawerId": "profile-interests-edit",
                                    "editTitle": "Edit Interests",
                                    "editConfigId": "interestsEditConfig",
                                    "saveActionId": "save_profile_interests",
                                    "fields": [
                                        {
                                            "componentType": "textArea",
                                            "name": "interests",
                                            "label": "My interests and hobbies",
                                            "Json_Attribute": "interests",
                                            "BindValue": "interests",
                                            "columnNumber": "m1 t1 w1"
                                        }
                                    ]
                                }
                            ]
                        },
                        "job": {
                            "visibility": [
                                1,
                                2
                            ],
                            "sections": [
                                {
                                    "sectionId": "job_details",
                                    "title": "Job Details",
                                    "editVisibility": [1],
                                    "editDrawerId": "profile-job-details-edit",
                                    "editTitle": "Edit Job Details",
                                    "editConfigId": "jobDetailsEditConfig",
                                    "saveActionId": "save_profile_job_details",
                                    "fields": [
                                        {
                                            "componentType": "textField",
                                            "name": "job_employee_number",
                                            "label": "Employee Number",
                                            "Json_Attribute": "employee_number",
                                            "BindValue": "job_employee_number",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "job_date_of_joining",
                                            "label": "Date of Joining",
                                            "Json_Attribute": "date_of_joining",
                                            "BindValue": "job_date_of_joining",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "job_job_title_primary",
                                            "label": "Job Title Primary",
                                            "Json_Attribute": "job_title_primary",
                                            "BindValue": "job_job_title_primary",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "job_job_title_secondary",
                                            "label": "Job Title Secondary",
                                            "Json_Attribute": "job_title_secondary",
                                            "BindValue": "job_job_title_secondary",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "job_in_probation",
                                            "label": "In Probation?",
                                            "Json_Attribute": "job_in_probation",
                                            "BindValue": "job_in_probation",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "job_notice_period",
                                            "label": "Notice Period",
                                            "Json_Attribute": "job_notice_period",
                                            "BindValue": "job_notice_period",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "selectDropdown",
                                            "name": "job_worker_type",
                                            "label": "Worker Type",
                                            "Json_Attribute": "job_worker_type",
                                            "BindValue": "job_worker_type",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "selectDropdown",
                                            "name": "job_time_type",
                                            "label": "Time Type",
                                            "Json_Attribute": "job_time_type",
                                            "BindValue": "job_time_type",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "job_contract_status",
                                            "label": "Contract Status",
                                            "Json_Attribute": "job_contract_status",
                                            "BindValue": "job_contract_status",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "job_pay_band",
                                            "label": "Pay Band",
                                            "Json_Attribute": "job_pay_band",
                                            "BindValue": "job_pay_band",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "job_pay_grade",
                                            "label": "Pay Grade",
                                            "Json_Attribute": "job_pay_grade",
                                            "BindValue": "job_pay_grade",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "organization",
                                    "title": "Organization",
                                    "editVisibility": [1],
                                    "editDrawerId": "profile-organization-edit",
                                    "editTitle": "Edit Organization",
                                    "editConfigId": "organizationEditConfig",
                                    "saveActionId": "save_profile_organization",
                                    "fields": [
                                        {
                                            "componentType": "textField",
                                            "name": "organization_business_unit",
                                            "label": "Business Unit",
                                            "Json_Attribute": "organization_business_unit",
                                            "BindValue": "organization_business_unit",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "searchableDropdown",
                                            "name": "organization_group_id",
                                            "label": "Group",
                                            "Json_Attribute": "group_id",
                                            "BindValue": "organization_group_id",
                                            "lookupName": "employee_group",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "organization_location",
                                            "label": "Location",
                                            "Json_Attribute": "organization_location",
                                            "BindValue": "organization_location",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "organization_cost_center",
                                            "label": "Cost Center",
                                            "Json_Attribute": "cost_center",
                                            "BindValue": "organization_cost_center",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "organization_legal_entity",
                                            "label": "Legal Entity",
                                            "Json_Attribute": "legal_entity",
                                            "BindValue": "organization_legal_entity",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "searchableDropdown",
                                            "name": "organization_reports_to",
                                            "label": "Reports To",
                                            "Json_Attribute": "reports_to",
                                            "BindValue": "organization_reports_to",
                                            "lookupName": "admin_employees",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "searchableDropdown",
                                            "name": "organization_manager_of_manager",
                                            "label": "Manager of Manager (L2 Manager)",
                                            "Json_Attribute": "organization_manager_of_manager",
                                            "BindValue": "organization_manager_of_manager",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "organization_direct_reports",
                                            "label": "Direct Reports",
                                            "Json_Attribute": "organization_direct_reports",
                                            "BindValue": "organization_direct_reports",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "searchableDropdown",
                                            "name": "organization_visa_branch",
                                            "label": "Visa Branch",
                                            "Json_Attribute": "visa_branch",
                                            "BindValue": "organization_visa_branch",
                                            "lookupName": "branches",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "searchableDropdown",
                                            "name": "organization_branch_id",
                                            "label": "Working Branch",
                                            "Json_Attribute": "branch_id",
                                            "BindValue": "organization_branch_id",
                                            "lookupName": "branches",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "employee_time",
                                    "title": "Employee Time",
                                    "editVisibility": [1],
                                    "editDrawerId": "profile-employee-time-edit",
                                    "editTitle": "Edit Employee Time",
                                    "editConfigId": "employeeTimeEditConfig",
                                    "saveActionId": "save_profile_employee_time",
                                    "fields": [
                                        {
                                            "componentType": "textField",
                                            "name": "employee_time_shift",
                                            "label": "Shift",
                                            "Json_Attribute": "employee_time_shift",
                                            "BindValue": "employee_time_shift",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "employee_time_weekly_off_policy",
                                            "label": "Weekly Off Policy",
                                            "Json_Attribute": "employee_time_weekly_off_policy",
                                            "BindValue": "employee_time_weekly_off_policy",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "employee_time_leave_plan",
                                            "label": "Leave Plan",
                                            "Json_Attribute": "employee_time_leave_plan",
                                            "BindValue": "employee_time_leave_plan",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "employee_time_holiday_calendar",
                                            "label": "Holiday Calendar",
                                            "Json_Attribute": "employee_time_holiday_calendar",
                                            "BindValue": "employee_time_holiday_calendar",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "inputType": "number",
                                            "name": "employee_time_attendance_number",
                                            "label": "Attendance Number",
                                            "Json_Attribute": "employee_time_attendance_number",
                                            "BindValue": "employee_time_attendance_number",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "employee_time_attendance_capture_scheme",
                                            "label": "Attendance Capture Scheme",
                                            "Json_Attribute": "employee_time_attendance_capture_scheme",
                                            "BindValue": "employee_time_attendance_capture_scheme",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "employee_time_attendance_penalization_policy",
                                            "label": "Attendance Penalization Policy",
                                            "Json_Attribute": "employee_time_attendance_penalization_policy",
                                            "BindValue": "employee_time_attendance_penalization_policy",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "employee_time_shift_weekly_off_rule",
                                            "label": "Shift Weekly Off Rule",
                                            "Json_Attribute": "employee_time_shift_weekly_off_rule",
                                            "BindValue": "employee_time_shift_weekly_off_rule",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "employee_time_shift_allowance_policy",
                                            "label": "Shift Allowance Policy",
                                            "Json_Attribute": "employee_time_shift_allowance_policy",
                                            "BindValue": "employee_time_shift_allowance_policy",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "employee_time_overtime",
                                            "label": "Overtime",
                                            "Json_Attribute": "employee_time_overtime",
                                            "BindValue": "employee_time_overtime",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        }
                                    ]
                                },
                                {
                                    "sectionId": "other",
                                    "title": "Other",
                                    "editVisibility": [1],
                                    "editDrawerId": "profile-other-edit",
                                    "editTitle": "Edit Other Settings",
                                    "editConfigId": "otherSettingsEditConfig",
                                    "saveActionId": "save_profile_other_settings",
                                    "fields": [
                                        {
                                            "componentType": "textField",
                                            "name": "other_expense_policy",
                                            "label": "Expense Policy",
                                            "Json_Attribute": "other_expense_policy",
                                            "BindValue": "other_expense_policy",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "other_loan_policy",
                                            "label": "Loan Policy",
                                            "Json_Attribute": "other_loan_policy",
                                            "BindValue": "other_loan_policy",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "other_air_ticket_policy",
                                            "label": "Air Ticket Policy",
                                            "Json_Attribute": "other_air_ticket_policy",
                                            "BindValue": "other_air_ticket_policy",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "other_sales_included",
                                            "label": "Include sales",
                                            "Json_Attribute": "sales_included",
                                            "BindValue": "other_sales_included",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "other_user_access",
                                            "label": "Enable user",
                                            "Json_Attribute": "user_access",
                                            "BindValue": "other_user_access",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        }
                                    ]
                                }
                            ]
                        },
                        "documents": {
                            "visibility": [
                                2
                            ],
                            "sections": [
                                {
                                    "sectionId": "upload_documents",
                                    "title": "Upload Documents",
                                    "editDrawerId": "profile-upload-documents-edit",
                                    "editTitle": "Upload Documents",
                                    "editConfigId": "uploadDocumentsEditConfig",
                                    "saveActionId": "save_profile_documents",
                                    "fields": [
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_aadhaar",
                                            "label": "Aadhaar Card",
                                            "maxFiles": 1,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_pan",
                                            "label": "PAN Card",
                                            "maxFiles": 1,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_voter_id",
                                            "label": "Voter ID Card",
                                            "maxFiles": 1,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_driving_license",
                                            "label": "Driving License",
                                            "maxFiles": 1,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_passport",
                                            "label": "Passport",
                                            "maxFiles": 1,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_degrees",
                                            "label": "Degrees & Certificates",
                                            "maxFiles": 5,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_10th",
                                            "label": "10th Certificate",
                                            "maxFiles": 1,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_12th",
                                            "label": "12th Certificate",
                                            "maxFiles": 1,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_experience_letter",
                                            "label": "Experience Letter",
                                            "maxFiles": 5,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_relieving_letter",
                                            "label": "Relieving Letter",
                                            "maxFiles": 5,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_payslip",
                                            "label": "3 Months Payslip",
                                            "maxFiles": 3,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_bank_details",
                                            "label": "Bank Details",
                                            "maxFiles": 1,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png",
                                                "application/pdf"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        },
                                        {
                                            "componentType": "imageUpload",
                                            "name": "document_passport_photo",
                                            "label": "Passport Size Colour Picture",
                                            "maxFiles": 1,
                                            "acceptedFileTypes": [
                                                "image/jpeg",
                                                "image/png"
                                            ],
                                            "previewEnabled": true,
                                            "columnNumber": "m1 t2 w3"
                                        }
                                    ]
                                }
                            ]
                        },
                        "assets": {
                            "visibility": [
                                1,
                                2
                            ],
                            "sections": [
                                {
                                    "sectionId": "assign_assets",
                                    "title": "Assign Assets",
                                    "editVisibility": [1],
                                    "editDrawerId": "profile-assign-assets-edit",
                                    "editTitle": "Assign Assets",
                                    "editConfigId": "assignAssetsEditConfig",
                                    "saveActionId": "save_profile_assets",
                                    "fields": [
                                        {
                                            "componentType": "searchableDropdown",
                                            "name": "asset_type",
                                            "label": "Asset Type",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "searchableDropdown",
                                            "name": "asset_name",
                                            "label": "Asset Name",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "textField",
                                            "name": "asset_category",
                                            "label": "Asset Category",
                                            "inputType": "text",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "dateField",
                                            "name": "asset_assigned_on",
                                            "label": "Assigned On",
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "selectDropdown",
                                            "name": "asset_acknowledgement_status",
                                            "label": "Acknowledgement Status",
                                            "options": [
                                                {
                                                    "label": "Acknowledged",
                                                    "value": "acknowledged"
                                                },
                                                {
                                                    "label": "Pending",
                                                    "value": "pending"
                                                },
                                                {
                                                    "label": "Not Applicable",
                                                    "value": "not_applicable"
                                                }
                                            ],
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        },
                                        {
                                            "componentType": "selectDropdown",
                                            "name": "asset_latest_condition",
                                            "label": "Latest Condition",
                                            "options": [
                                                {
                                                    "label": "Good",
                                                    "value": "good"
                                                },
                                                {
                                                    "label": "Fair",
                                                    "value": "fair"
                                                },
                                                {
                                                    "label": "Poor",
                                                    "value": "poor"
                                                },
                                                {
                                                    "label": "Damaged",
                                                    "value": "damaged"
                                                }
                                            ],
                                            "columnNumber": "m1 t2 w3",
                                            "isReadOnly": true,
                                            "disabled": true
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                }
            }
        ]
    }
];
